import { render, staticRenderFns } from "./Accessad.vue?vue&type=template&id=67b2548b&"
import script from "./Accessad.vue?vue&type=script&lang=js&"
export * from "./Accessad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports